import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import { prettyMoney } from '@scramble/utils';
import { EMPTY_DASH } from '@/helpers/constants';
import { useGetBalance } from '@/query/queries/cash/useGetBalance';
import { APP_LINKS } from '@/helpers/links';
import { useAllocationBalance } from './useAllocationBalance';
import IconPlus from '@scramble/design-system/icons/plus-circle.svg?react';
import s from './index.module.scss';

export const Balance = ({
  isLoading,
  allocatedGroupA,
  allocatedGroupB,
  confirmedAllocationGroupA,
  confirmedAllocationGroupB,
  confirmedBonusAmount,
}) => {
  const { t } = useTranslation();
  const { data: balance } = useGetBalance();
  const navigate = useNavigate();
  const { availableCashAmount, availableBonusAmount, total } =
    useAllocationBalance({
      allocatedGroupA,
      allocatedGroupB,
      confirmedAllocationGroupA,
      confirmedAllocationGroupB,
      confirmedBonusAmount,
    });

  const onAddCash = () => {
    navigate(APP_LINKS.addFunds);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.left}>
        <div className={s.group} style={{ gridArea: 'total' }}>
          <div className={s.amount}>
            {balance && !isLoading ? prettyMoney(total) : EMPTY_DASH}
          </div>
          <div className={s.label}>{t('investing:balance.total')}</div>
        </div>
        <div className={s.group} style={{ gridArea: 'cash' }}>
          <div className={s.amount}>
            {balance && !isLoading
              ? prettyMoney(availableCashAmount)
              : EMPTY_DASH}
          </div>
          <div className={s.label}>{t('investing:balance.available_cash')}</div>
        </div>
        <div className={s.group} style={{ gridArea: 'bonus' }}>
          <div className={s.amount}>
            {balance && !isLoading
              ? prettyMoney(availableBonusAmount)
              : EMPTY_DASH}
          </div>
          <div className={s.label}>
            {t('investing:balance.bonuses_group_a')}
          </div>
        </div>
      </div>
      <Button
        theme="neutral"
        appearance="filled"
        size="lg"
        onClick={onAddCash}
        className={s.btn_add_cash}
      >
        <IconPlus className={s.btn_add_icon} />
        <span>{t('investing:balance.add_cash')}</span>
      </Button>
    </div>
  );
};
